import Constants from "common/constant";
import { ProgramProgress } from "features/courses/types";
import { StageLevelRects } from "features/courses/program/stage/StageLevelRects";
import { StageLevelPaths } from "features/courses/program/stage/StageLevelPaths";

export const LevelAnimation = ({
  offset,
  scale,
  stroke,
  radius,
  stage,
  progresses,
}: {
  offset: number;
  scale: number;
  stroke: number;
  radius: number;
  stage: number;
  progresses: ProgramProgress;
}) => (
  <>
    <div
      className="absolute z-[-1] w-full h-full"
      style={{ filter: "drop-shadow(2px 2px 3px rgba(63, 74, 97, 0.5))" }}
    >
      <svg className="absolute z-[-1] w-full h-full">
        {progresses.level.map((level, index) => (
          <g key={index}>
            <path
              overflow="visible"
              d={StageLevelPaths[stage - 1](radius, scale, offset)[index]}
              fill="transparent"
              stroke={
                level.is_finished
                  ? index < progresses.stage.animation
                    ? "#F9E531"
                    : "white"
                  : "rgb(156,157,163)"
              }
              strokeWidth={stroke * 1.5 * scale}
            />
          </g>
        ))}
      </svg>
      {progresses.level.map((level, index) => {
        return (
          <div
            key={index}
            id={`level-animation-circle-${index}`}
            className="flex-col-view !absolute top-0 left-0 overflow-visible"
            style={{
              width: (radius * 2 + stroke) * scale,
              height: (radius * 2 + stroke) * scale,
              transform: `translate(${
                (StageLevelRects[stage - 1][index].left - stroke) * scale +
                offset
              }px, ${
                (StageLevelRects[stage - 1][index].top - stroke) * scale
              }px)`,
            }}
          >
            <svg
              overflow="visible"
              width={(radius * 2 + stroke) * scale}
              height={(radius * 2 + stroke) * scale}
              viewBox={`${(-stroke / 2) * scale} ${(-stroke / 2) * scale} ${
                (radius * 2 + stroke) * scale
              } ${(radius * 2 + stroke) * scale}`}
            >
              <g overflow="visible">
                <rect
                  x={0}
                  y={0}
                  width={(radius * 2 + stroke) * scale}
                  height={(radius * 2 + stroke) * scale}
                  fill="none"
                  stroke={
                    level.is_finished
                      ? index < progresses.stage.animation
                        ? "#F9E531"
                        : "white"
                      : index === progresses.stage.finished
                      ? "white"
                      : "rgb(156,157,163)"
                  }
                  strokeWidth={stroke * scale}
                />
              </g>
            </svg>
          </div>
        );
      })}
    </div>

    {progresses.level.map((level, index) => {
      return (
        <div
          key={index}
          className="flex-col-center !absolute top-0 left-0 z-0 w-[140px] h-[52px] origin-top-left pointer-events-none"
          style={{
            transform: `translate(${
              (StageLevelRects[stage - 1][index].left + 30) * scale + offset
            }px, ${
              (StageLevelRects[stage - 1][index].top - 40) * scale
            }px) scale(${scale})`,
            opacity: level.is_finished ? 1 : 0,
          }}
        >
          <img
            id={`level-animation-clear-image-${index}`}
            alt="*"
            src={`${Constants.assetHost}/assets/images/levelcrear_s@2x.png`}
            className="w-full h-full"
          />
        </div>
      );
    })}
  </>
);
